// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"zx","quote":"zy","quoteAuthor":"zz"};